import { render, staticRenderFns } from "./qandaPage.vue?vue&type=template&id=03b96454&"
import script from "./qandaPage.vue?vue&type=script&lang=js&"
export * from "./qandaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports